
document.addEventListener('DOMContentLoaded', function() {
  // Create a MutationObserver to watch for wishlist buttons
  const observer = new MutationObserver(function(mutations, obs) {
    const wishlistButtons = document.querySelectorAll('.wishlist-btn');
    
    if (wishlistButtons.length > 0) {
      // Found the buttons — init wishlist
      initWishlist();

      // Stop observing once done
      obs.disconnect();
    }
  });

  // Start observing the document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

function initWishlist() {
  const wishlistButtons = document.querySelectorAll('.wishlist-btn');

  console.log("wishlistButtons",wishlistButtons)
  
  wishlistButtons.forEach(button => {
    // Check if product is already in wishlist
    const productId = button.dataset.productId;
    if (isInWishlist(productId)) {
      button.classList.add('active');
      button.querySelector('i').classList.remove('bi-heart');
      button.querySelector('i').classList.add('bi-heart-fill');
      button.setAttribute('title', 'Remove from wishlist');
    }
    
    // Add click event listener
    button.addEventListener('click', function(e) {
      console.log("Clicked")
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(this);
    });
  });
}

function toggleWishlist(button) {
  const productData = {
    id: button.dataset.productId,
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    price: button.dataset.productPrice,
    compare_at_price: button.dataset.productComparePrice,
    image: button.dataset.productImage,
    url: button.dataset.productUrl,
    vendor: button.dataset.productVendor
  };
  
  const isActive = button.classList.contains('active');
  
  if (isActive) {
    removeFromWishlist(productData.id);
    button.classList.remove('active');
    button.querySelector('i').classList.remove('bi-heart-fill');
    button.querySelector('i').classList.add('bi-heart');
    button.setAttribute('title', 'Add to wishlist');
    showNotification('Removed from wishlist');
  } else {
    addToWishlist(productData);
    button.classList.add('active');
    button.querySelector('i').classList.remove('bi-heart');
    button.querySelector('i').classList.add('bi-heart-fill');
    button.setAttribute('title', 'Remove from wishlist');
    showNotification('Added to wishlist');
  }
}

function addToWishlist(product) {
  let wishlist = getWishlist();
  
  // Check if product already exists
  const existingIndex = wishlist.findIndex(item => item.id === product.id);
  
  if (existingIndex === -1) {
    wishlist.push({
      ...product,
      added_at: new Date().toISOString()
    });
    localStorage.setItem('shopify_wishlist', JSON.stringify(wishlist));
  }
}

function removeFromWishlist(productId) {
  let wishlist = getWishlist();
  wishlist = wishlist.filter(item => item.id !== productId);
  localStorage.setItem('shopify_wishlist', JSON.stringify(wishlist));
}

function getWishlist() {
  const wishlist = localStorage.getItem('shopify_wishlist');
  return wishlist ? JSON.parse(wishlist) : [];
}

function isInWishlist(productId) {
  const wishlist = getWishlist();
  return wishlist.some(item => item.id === productId);
}

function showNotification(message) {
  // // Simple notification - you can enhance this
  // const notification = document.createElement('div');
  // notification.style.cssText = `
  //   position: fixed;
  //   top: 20px;
  //   right: 20px;
  //   background: #28a745;
  //   color: white;
  //   padding: 12px 20px;
  //   border-radius: 4px;
  //   z-index: 10000;
  //   font-size: 14px;
  // `;
  // notification.textContent = message;
  // document.body.appendChild(notification);
  
  // setTimeout(() => {
  //   notification.remove();
  // }, 30000);
}

// Function to create Bootstrap icon element
function createBootstrapIcon(iconClass) {
    const icon = document.createElement('i');
    icon.className = `bi ${iconClass}`;
    icon.style.fontSize = '1rem';
    icon.style.transition = 'transform 0.2s ease';
    return icon;
}

// Function to replace caret icons with Bootstrap plus/minus icons
function replaceAccordionIcons() {
    // Find all accordion sections
    const accordions = document.querySelectorAll('.product__accordion details');
    
    accordions.forEach(details => {
        const summary = details.querySelector('summary');
        const caretIcon = summary.querySelector('.icon-caret');
        
        if (caretIcon) {
            // Remove the existing caret icon
            caretIcon.remove();
            
            // Create the appropriate Bootstrap icon based on open state
            const isOpen = details.hasAttribute('open');
            const iconClass = isOpen ? 'bi-dash' : 'bi-plus';
            const bootstrapIcon = createBootstrapIcon(iconClass);
            
            // Add the new icon to the summary
            summary.appendChild(bootstrapIcon);
            
            // Add click event listener to toggle icons
            summary.addEventListener('click', function(e) {
                // Use setTimeout to check state after the toggle
                setTimeout(() => {
                    const isNowOpen = details.hasAttribute('open');
                    const currentIcon = summary.querySelector('i.bi');
                    
                    if (currentIcon) {
                        // Update icon class
                        currentIcon.className = isNowOpen ? 'bi bi-dash' : 'bi bi-plus';
                    }
                }, 10);
            });
        }
    });
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceAccordionIcons);
} else {
    replaceAccordionIcons();
}

// Optional: Also handle dynamically added accordions
// Create a MutationObserver to watch for new accordion elements
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.querySelector) {
                const newAccordions = node.querySelectorAll('.product__accordion details');
                if (newAccordions.length > 0) {
                    replaceAccordionIcons();
                }
            }
        });
    });
});

// Start observing
observer.observe(document.body, {
    childList: true,
    subtree: true
});